import { Link } from "react-router-dom";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { Reveal } from "../motion/Reveal";
import { AnimatedText } from "../motion/AnimatedText";
import { useC, useWa } from "../../context/SiteData";

export const FinalCta = () => {
  const c = useC();
  const wa = useWa();
  const title = c.cta_title;
  const text = c.cta_text;

  return (
    <section data-testid="final-cta" className="bg-ink-900">
      <div className="container-x section-y flex flex-col items-start gap-10 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-2xl">
          <Reveal>
            <p className="label flex items-center gap-3 text-cream-50/50">
              <span className="inline-block h-px w-8 bg-cream-50/40" />
              {c.cta_label}
            </p>
          </Reveal>
          <h2 className="mt-4 text-3xl font-bold leading-[1.15] tracking-tight text-cream-50 sm:text-4xl lg:text-5xl">
            <AnimatedText text={title.split("\n")} delay={0.05} stagger={0.05} />
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-5 text-base leading-relaxed text-cream-50/65 sm:text-lg">{text}</p>
          </Reveal>
        </div>
        <Reveal delay={0.24} className="flex flex-col gap-3 sm:flex-row">
          <a
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp"
            className="btn-light"
          >
            <WhatsAppIcon size={15} />
            WhatsApp'tan Bilgi Al
          </a>
          <Link to="/iletisim" data-testid="final-cta-contact" className="btn-outline-light">
            İletişime Geç
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
